import API from '.';

export default class LocationSourceSystemRelate {
  constructor({
    locationSourceSystemId,
    locationId,
    sourceSystemIdTypeId,
    sourceSystemReferenceId,
  }) {
    this.LocationSourceSystemId = locationSourceSystemId;
    this.LocationId = locationId;
    this.SourceSystemIdTypeId = sourceSystemIdTypeId;
    this.SourceSystemReferenceId = sourceSystemReferenceId;
  }

  static validateSourceSystemReferenceIdWithinCountry(
    sourceSystemIdTypeId,
    sourceSystemReferenceId,
    countryId
  ) {
    const api = API();
    return new Promise((resolve) => {
      resolve(
        api.get(
          'LocationSourceSystemRelate/ValidateSourceSystemReferenceIdWithinCountry',
          {
            params: {
              sourceSystemIdTypeId: sourceSystemIdTypeId,
              sourceSystemReferenceId: sourceSystemReferenceId,
              countryId: countryId,
            },
          }
        )
      );
    });
  }

  static validateSourceSystemReferenceId(
    sourceSystemIdTypeId,
    sourceSystemReferenceId
  ) {
    const api = API();
    return new Promise((resolve) => {
      resolve(
        api.get(
          'LocationSourceSystemRelate/ValidateSourceSystemReferenceId',
          {
            params: {
              sourceSystemIdTypeId: sourceSystemIdTypeId,
              sourceSystemReferenceId: sourceSystemReferenceId
            },
          }
        )
      );
    });
  }
}
